<template>
  <div class="mt-5 text-muted small">
    <div class="row">
      <div class="col-6 text-right">Gateway backend:</div>
      <div class="col-6 text-left"><strong>{{ newCoreBackend }}</strong></div>
    </div>
    <div class="row">
      <div class="col-6 text-right">UI version:</div>
      <div class="col-6 text-left"><strong>{{ version }}</strong></div>
    </div>
    <div class="row" v-if="!!defaultProductId">
      <div class="col-6 text-right">Default product id:</div>
      <div class="col-6 text-left"><strong>{{ defaultProductId }}</strong></div>
    </div>
    <div class="row">
      <div class="col-6 text-right">GetID backend:</div>
      <div class="col-6 text-left"><strong>{{ identityVerificationUrl }}</strong></div>
    </div>
    <div class="row">
      <div class="col-6 text-right">PKI enabled: </div>
      <div class="col-6 text-left"><strong>{{ isPkiEnabled }}</strong></div>
    </div>
    <div class="row">
      <div class="col-6 text-right">Identity verification enabled: </div>
      <div class="col-6 text-left"><strong>{{ isIdentityVerificationEnabled }}</strong></div>
    </div>
    <div class="row">
      <div class="col-6 text-right">Deep Linking enabled: </div>
      <div class="col-6 text-left"><strong>{{ isDeepLinkingEnabled }}</strong></div>
    </div>
    <div class="row">
      <div class="col-6 text-right">Chat enabled: </div>
      <div class="col-6 text-left"><strong>{{ isChatEnabled }}</strong></div>
    </div>
  </div>
</template>
<script>

import settings from '@shared/settings'

export default {
  name: 'DevelopmentInformation',
  computed: {
    newCoreBackend() {
      return this.$configuration.newCoreEnabled ? 'New Core' : 'LES'
    },
    identityVerificationUrl() {
      return this.$configuration.identityVerificationUrl
    },
    isPkiEnabled() {
      return settings.featureFlags.isPkiSigningEnabled()
    },
    isIdentityVerificationEnabled() {
      return settings.featureFlags.isIdentityVerificationEnabled()
    },
    isDeepLinkingEnabled() {
      return settings.featureFlags.isDeepLinkingEnabled()
    },
    isBiometricLoginEnabled() {
      return settings.featureFlags.isBiometricLoginEnabled()
    },
    isChatEnabled() {
      return settings.featureFlags.isChatEnabled()
    },
    version() {
      return document.getElementsByTagName('meta').namedItem('version').content
    },
    defaultProductId() {
      return this.$configuration.basic && this.$configuration.basic.id
    }
  }
}
</script>
